<app-button *ngIf="rawFilters" mode="secondary" class="opleiding-overzicht__result-button" data-cy="filterResultsButton" (clicked)="openFilterModal()">
  <mat-icon style="margin-right: 0.5rem; flex-shrink: 0;">filter_list</mat-icon>
  <span class="hide-on-small">Uitgebreid&nbsp;</span>filter
</app-button>
